import { Texture } from "../../../texture";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";

export type RetouchComponentProps = {
  texture: Texture;
  maskTexture: Texture;
};

type RetouchComponentState = {
  u_strength: number;
  u_sampleRadius: number;
};

export class RetouchComponent extends Webgl2Component<
  RetouchComponentProps,
  RetouchComponentState
> {
  constructor(initialState: RetouchComponentState) {
    super(initialState);
  }

  public getRenderData(props: RetouchComponentProps) {
    const material = Webgl2.materials.retouch;
    material.setTexture("u_texture0", props.texture);
    material.setTexture("u_texture1", props.maskTexture);
    material.setUniforms({
      u_size: this.transform.size.getAbs().getArray(),
      u_strength: this.state.u_strength,
      u_sampleRadius: this.state.u_sampleRadius,
    });
    return { material };
  }
}

export default RetouchComponent;
